<!-- StepComparisonFinalReport.vue -->
<template>
    <div class="modal_final">
      <div class="modal_main_inputs_head">
        Отчет по сравнению документов
      </div>
      
      <div class="modal_final_content">
        <!-- Левая колонка -->
        <div class="modal_final_left">
          <!-- Блок 1: Тип документа (статический) -->
          <div class="info-block">
            <div class="info-block-header">
              <div class="info-block-title">Тип документа</div>
              <div class="info-block-status">Регламент</div>
            </div>
            <div class="info-block-description">
              Документ успешно распознан как регламент
            </div>
          </div>
  
          <!-- Блок 2: Результаты сравнения -->
          <div class="comparison-results">
            <div class="comparison-header">
              <div class="head_logo">
                <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24"
                  fill="none" stroke="oklch(.792 .209 151.711)" stroke-width="2" stroke-linecap="round"
                  stroke-linejoin="round">
                  <path d="M21.801 10A10 10 0 1 1 17 3.335"></path>
                  <path d="m9 11 3 3L22 4"></path>
                </svg>
              </div>
              <h2>Результаты сравнения</h2>
            </div>
  
            <!-- Карточки с результатами -->
            <div class="conformity-cards">
              <div v-for="(item, index) in conformityTable" :key="index" class="conformity-card" :class="getPriorityClass(item.priority)">
                <div class="card-header">
                  <span class="card-title">{{ item.parameter }}</span>
                  <span class="card-status" :class="getComplianceClass(item.compliance)">{{ item.compliance }}</span>
                </div>
                <div class="card-comment">{{ item.comment }}</div>
                <div class="card-recommendation" v-if="item.recommendation">
                  <strong>Рекомендация:</strong> {{ item.recommendation }}
                </div>
              </div>
            </div>
  
            <!-- Следующие шаги -->
            <div class="next-steps" v-if="comparisonData?.final_comparison_assessment?.next_steps?.length">
              <h3>Рекомендуемые действия</h3>
              <ul>
                <li v-for="(step, index) in comparisonData.final_comparison_assessment.next_steps" :key="index">
                  {{ step }}
                </li>
              </ul>
            </div>
          </div>
        </div>
  
        <!-- Правая колонка - информация об отчете -->
        <div class="modal_final_right">
          <!-- Блок с ценой отчета -->
          <div class="price-block">
            <div class="price-header">
              <div class="price-title">Стоимость отчета</div>
              <div class="price-value">{{ price }}</div>
              <div class="price-description">{{ priceDescription }}</div>
            </div>
            <div class="price-features">
              <div v-for="(item, index) in finalItems" :key="index" class="price-feature">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#8A75FF" stroke-width="2">
                  <path d="M20 6L9 17L4 12" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
                <span>{{ item }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      <!-- Кнопки действий -->
      <div class="modal_final_actions">
        <div class="modal_main_load_content_btn restart-btn" @click="$emit('restart')">
          <span>Начать сначала</span>
        </div>
      </div>
  
    <!-- Блок с email и скачиванием -->
    <div class="download-section">
      <div class="download-title">Укажите email для получения отчета</div>
      
      <!-- Показываем форму только если нет ссылки -->
      <template v-if="!reportUrl">
        <div class="download-form">
          <input 
            type="email" 
            v-model="email" 
            @input="validateEmail"
            placeholder="Введите ваш email"
            class="email-input"
            :class="{ 'invalid': !isEmailValid && email !== '' }"
          />
          
          <div class="modal_main_load_content_btn download-btn" 
     @click.prevent.stop="handleDownload"
     :class="{ 'disabled': !isEmailValid || isDownloading }"
     style="cursor: pointer;">
            <span v-if="isDownloading">Отправка...</span>
            <span v-else>Получить ссылку</span>
          </div>
        </div>
        <div v-if="emailError" class="error-message">{{ emailError }}</div>
      </template>
      
      <!-- Показываем кнопку-ссылку когда ссылка получена -->
      <div v-else class="download-result">
        <a :href="reportUrl" target="_blank" class="modal_main_load_content_btn download-btn success">
          Скачать отчет
        </a>
      </div>
    </div>
    </div>
  </template>
  
  <script>
  export default {
    name: 'StepComparisonFinalReport',
    props: {
      comparisonData: {
        type: Object,
        default: () => ({})
      },
      finalItems: {
        type: Array,
        default: () => [
          'Сравнение документов',
          'Анализ структуры',
          'Соответствие ролевой модели',
          'Метрики и цели',
          'Рекомендации по улучшению',
          'PDF отчёт (до 50 страниц)'
        ]
      },
      price: {
        type: String,
        default: 'Free'
      },
      priceDescription: {
        type: String,
        default: 'Единоразовая плата'
      },
      taskId: {
        type: String,
        default: ''
      }
    },
    emits: ['restart', 'download', 'share', 'save'],
    data() {
      return {
        email: '',
        isEmailValid: false,
        isDownloading: false,
        emailError: '',
        reportUrl: null
      }
    },
    computed: {
        conformityTable() {
            return this.comparisonData?.structureData?.conformity_table || []
        }
    },
    methods: {
        getPriorityClass(priority) {
      const classes = {
        'Низкий': 'priority-low',
        'Средний': 'priority-medium',
        'Высокий': 'priority-high'
      }
      return classes[priority] || ''
    },
      
    getComplianceClass(compliance) {
      const classes = {
        'Соответствует': 'compliance-ok',
        'Частично соответствует': 'compliance-partial',
        'Не соответствует': 'compliance-bad'
      }
      return classes[compliance] || 'compliance-unknown'
    },
      
      formatCost(value) {
        const num = parseInt(value) || 0
        return new Intl.NumberFormat('ru-RU').format(num)
      },
      
      validateEmail() {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
        this.isEmailValid = emailRegex.test(this.email)
        this.emailError = ''
      },
      
      async handleDownload(event) {
  // Жестко запрещаем всё
  if (event) {
    event.preventDefault()
    event.stopPropagation()
  }
  
  // Принудительно оставляем скролл на месте
  const scrollX = window.scrollX
  const scrollY = window.scrollY
  
  if (this.reportUrl) {
    return
  }
  
  if (!this.isEmailValid || this.isDownloading || !this.taskId) return
  
  this.isDownloading = true
  this.emailError = ''
  
  try {
    const contactResponse = await fetch(`${this.$parent?.ApiLink || ''}/api/v1/tasks/contacts`, {
      method: 'POST',
      headers: {
        'accept': 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        task_id: this.taskId,
        email: this.email,
        tg_id: "",
        username: "",
        first_name: "",
        last_name: ""
      })
    })
    
    if (!contactResponse.ok) {
      throw new Error('Ошибка при отправке email')
    }
    
    // Задержка 5 секунд для второго сценария
    if (this.$options.name === 'StepComparisonFinalReport') {
      await new Promise(resolve => setTimeout(resolve, 5000))
    }
    
    this.reportUrl = `${this.$parent?.ApiLink || ''}/api/v1/tasks/${this.taskId}/report`
    
  } catch (error) {
    console.error('Ошибка:', error)
    this.emailError = 'Не удалось получить ссылку. Попробуйте позже.'
  } finally {
    this.isDownloading = false
  }
},
  }
}
  </script>
  
  <style scoped>
  .modal_main_inputs_head {
    text-align: start;
    margin-bottom: 24px;
    font-size: 24px;
    font-weight: 600;
  }
  
  .modal_final_content {
    display: flex;
    gap: 24px;
    width: 100%;
  }
  
  .modal_final_left,
  .modal_final_right {
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 24px;
  }
  
  /* Стили для блока "Тип документа" */
  .info-block {
    background: #ffffff0a;
    border: 1px solid #403F6D;
    border-radius: 16px;
    padding: 20px;
  }
  
  .info-block-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 12px;
  }
  
  .info-block-title {
    font-size: 16px;
    font-weight: 600;
    color: #8A75FF;
  }
  
  .info-block-status {
    background: #00aa0020;
    color: #00ff00;
    border: 1px solid #00ff00;
    padding: 4px 12px;
    border-radius: 20px;
    font-size: 14px;
  }
  
  .info-block-description {
    color: #888;
    font-size: 14px;
    line-height: 1.5;
    text-align: start;
  }
  
  /* Стили для результатов сравнения */
  .comparison-results {
    background: #ffffff0a;
    border: 1px solid #403F6D;
    border-radius: 16px;
    padding: 20px;
  }
  
  .comparison-header {
    text-align: center;
    margin-bottom: 24px;
  }
  
  .comparison-header h2 {
    margin: 12px 0 0;
    font-size: 20px;
    color: #8A75FF;
  }
  
  .head_logo {
    display: flex;
    justify-content: center;
    width: max-content;
    margin: 0 auto;
  }
  
  .conformity-cards {
    display: flex;
    flex-direction: column;
    gap: 16px;
    margin-bottom: 24px;
  }
  
  .conformity-card {
    background: #ffffff15;
    border: 1px solid #403F6D;
    border-radius: 16px;
    padding: 16px;
  }
  
  .card-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 12px;
    flex-wrap: wrap;
    gap: 8px;
  }
  
  .card-title {
    font-size: 16px;
    font-weight: 600;
  }
  
  .card-status {
    padding: 4px 12px;
    border-radius: 20px;
    font-size: 12px;
    font-weight: 500;
    white-space: nowrap;
  }
  
  .compliance-ok {
    background: #00aa0020;
    color: #00ff00;
    border: 1px solid #00ff00;
  }
  
  .compliance-partial {
    background: #ffff0020;
    color: #ffff00;
    border: 1px solid #ffff00;
  }
  
  .compliance-bad {
    background: #ff000020;
    color: #ff6b6b;
    border: 1px solid #ff6b6b;
  }
  
  .compliance-unknown {
    background: #ffff0020;
    color: #ffff00;
    border: 1px solid #ffff00;
  }
  
  .priority-low {
    border-left: 4px solid #00ff00;
  }
  
  .priority-medium {
    border-left: 4px solid #ffff00;
  }
  
  .priority-high {
    border-left: 4px solid #ff6b6b;
  }
  
  .card-comment {
    color: #888;
    line-height: 1.5;
    margin-bottom: 12px;
    font-size: 14px;
  }
  
  .card-recommendation {
    color: #fff;
    padding: 8px 12px;
    background: #ffffff08;
    border-radius: 8px;
    font-size: 13px;
  }
  
  .next-steps {
    margin-top: 16px;
  }
  
  .next-steps h3 {
    font-size: 16px;
    margin-bottom: 12px;
    color: #8A75FF;
  }
  
  .next-steps ul {
    list-style: none;
    padding: 0;
  }
  
  .next-steps li {
    padding: 8px 12px;
    background: #ffffff08;
    border-radius: 8px;
    margin-bottom: 6px;
    color: #fff;
    font-size: 13px;
  }
  
  /* Стили для блока с ценой */
  .price-block {
    background: #ffffff0a;
    border: 1px solid #403F6D;
    border-radius: 16px;
    overflow: hidden;
  }
  
  .price-header {
    background: #8A75FF20;
    padding: 20px;
    text-align: center;
    border-bottom: 1px solid #403F6D;
  }
  
  .price-title {
    color: #888;
    font-size: 14px;
    margin-bottom: 8px;
  }
  
  .price-value {
    color: #8A75FF;
    font-size: 36px;
    font-weight: 700;
    margin-bottom: 4px;
  }
  
  .price-description {
    color: #8A75FF;
    font-size: 12px;
  }
  
  .price-features {
    padding: 20px;
  }
  
  .price-feature {
    display: flex;
    align-items: center;
    gap: 12px;
    margin-bottom: 12px;
    color: #fff;
    font-size: 14px;
  }
  
  .price-feature svg {
    flex-shrink: 0;
  }
  
  /* Кнопки действий */
  .modal_final_actions {
    margin-top: 24px;
  }
  
  .modal_main_load_content_btn {
    display: flex;
    gap: 8px;
    padding: 18px 40px;
    background: #8A75FF;
    justify-content: center;
    border-radius: 24px;
    cursor: pointer;
    transition: opacity 0.3s;
    width: 100%;
  }
  
  .modal_main_load_content_btn:hover {
    opacity: 0.9;
  }
  
  /* Блок с email */
  .download-section {
    margin-top: 32px;
    padding: 24px;
    background: #ffffff0a;
    border: 1px solid #403F6D;
    border-radius: 16px;
  }
  
  .download-title {
    font-size: 18px;
    font-weight: 600;
    color: #8A75FF;
    margin-bottom: 16px;
    text-align: start;
  }
  
  .download-form {
    display: flex;
    gap: 16px;
    align-items: center;
  }
  
  .email-input {
    flex: 1;
    background: #ffffff0a;
    border: 1px solid #403F6D;
    border-radius: 12px;
    padding: 16px 20px;
    color: #fff;
    font-size: 16px;
    transition: all 0.3s;
  }
  
  .email-input:focus {
    outline: none;
    border-color: #8A75FF;
    background: #ffffff15;
  }
  
  .email-input.invalid {
    border-color: #ff6b6b;
  }
  
  .email-input::placeholder {
    color: #666;
  }
  
  .download-btn {
    width: auto;
    min-width: 200px;
    padding: 16px 32px;
  }
  
  .download-btn.disabled {
    opacity: 0.5;
    cursor: not-allowed;
    pointer-events: none;
  }
  
  .download-link {
    margin-top: 12px;
    text-align: start;
  }
  
  .report-link {
    color: #8A75FF;
    text-decoration: underline;
    font-size: 14px;
    cursor: pointer;
  }
  
  .report-link:hover {
    opacity: 0.8;
  }
  
  .error-message {
    color: #ff6b6b;
    font-size: 14px;
    margin-top: 8px;
    text-align: start;
  }
  
  @media (max-width: 1024px) {
    .modal_final_content {
      flex-direction: column;
    }
  }
  
  @media (max-width: 768px) {
    .download-form {
      flex-direction: column;
    }
    
    .download-btn {
      width: 100%;
    }
    
    .card-header {
      flex-direction: column;
      align-items: flex-start;
    }
  }
  .download-result {
  display: flex;
  justify-content: center;
  margin-top: 16px;
}

.download-btn.success {
  background: #00aa00;
  min-width: 200px;
  text-decoration: none;
  color: white;
  width: 100%;
}

.download-btn.success:hover {
  background: #00cc00;
}
  </style>